// extracted by mini-css-extract-plugin
export default {"container":"SubmissionCard_container__5kE09","imageInnerContainer":"SubmissionCard_imageInnerContainer__U05dO"};